export const USER_SIGNIN = 'USER_SIGNIN' // 登录
export const USER_SIGNOUT = 'USER_SIGNOUT' // 退出登录
export const SET_COLLEC_TDATA = 'SET_COLLEC_TDATA' // 设置收货数据
export const SET_PICKING_TDATA_KEY = 'SET_PICKING_TDATA_KEY'
export const DELETE_PICKING_TDATA = 'DELETE_PICKING_TDATA' // 删除拣货数据的某个元素
export const SET_PICKING_TDATA = 'SET_PICKING_TDATA' // 设置拣货数据
export const SET_BLUETOOTH_DATA = 'SET_BLUETOOTH_DATA' // 设置蓝牙数据



// WEBPACK FOOTER //
// ./src/store/type.js